import sub from "./main.js";
import "../scss/main.scss";

console.log("webpack");
sub();
